class FeaturedCollectionSplide extends HTMLElement {
	constructor() {
		super()
		this.element = this.querySelector(".splide")
		this.instance = null
		this.sectionId = this.dataset.sectionId
		this.mobileEnabled = this.element.dataset.mobileSlider === "true"
		this.desktopEnabled = this.element.dataset.desktopSlider === "true"
		this.mobileColumns = Number(this.element.dataset.columnsMobile) || 1
		this.desktopColumns = Number(this.element.dataset.columnsDesktop) || 4
		this.fullWidth = this.element.dataset.fullWidth === "true"
		this.currentElement = this.element.querySelector("[data-splide-current]")
		this.totalElement = this.element.querySelector("[data-splide-total]")
		this.handleResize = this.debounce(() => this.updateState(), 150)

		this.updateState()
		window.addEventListener("resize", this.handleResize)
		document.addEventListener("shopify:section:unload", event => {
			if (event.detail.sectionId === this.sectionId) {
				this.destroy()
				window.removeEventListener("resize", this.handleResize)
			}
		})
	}

	isDesktop() {
		return window.matchMedia("(min-width: 990px)").matches
	}

	shouldEnableSlider() {
		return this.isDesktop() ? this.desktopEnabled : this.mobileEnabled
	}

	getOptions() {
		const desktop = this.isDesktop()
		const perPage = desktop ? this.desktopColumns : this.mobileColumns
		const padding = desktop
			? this.fullWidth ? { left: "1.5rem", right: "1.5rem" } : { left: "5rem", right: "5rem" }
			: { left: "1.5rem", right: "1.5rem" }

		return {
			type: "slide",
			rewind: false,
			perPage,
			perMove: 1,
			arrows: true,
			pagination: false,
			drag: true,
			gap: desktop
				? "var(--grid-desktop-horizontal-spacing)"
				: "var(--grid-mobile-horizontal-spacing)",
			padding
		}
	}

	updateCounter() {
		if (!this.instance || !this.currentElement || !this.totalElement) return
		const endIndex = this.instance.Components.Controller.getEnd()
		this.currentElement.textContent = String(this.instance.index + 1)
		this.totalElement.textContent = String(Math.max(endIndex + 1, 1))
	}

	mount() {
		if (this.instance || typeof Splide === "undefined") return
		this.instance = new Splide(`#${this.element.id}`, this.getOptions())
		this.instance.on("mounted moved updated resized", () => this.updateCounter())
		this.instance.mount()
	}

	destroy() {
		if (!this.instance) return
		this.instance.destroy(true)
		this.instance = null
	}

	updateState() {
		if (this.shouldEnableSlider()) {
			if (!this.instance) {
				this.mount()
			} else {
				this.instance.options = this.getOptions()
				this.updateCounter()
			}
		} else {
			this.destroy()
		}
	}

	debounce(callback, wait) {
		let timeoutId
		return (...args) => {
			clearTimeout(timeoutId)
			timeoutId = setTimeout(() => callback(...args), wait)
		}
	}
}

customElements.define("featured-collection-splide", FeaturedCollectionSplide)
